export const StatsSection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="text-center">
            <h3 className="text-5xl font-bold text-primary mb-2">90%</h3>
            <p className="text-muted-foreground">Time Saved on Daily Email Management</p>
          </div>
          <div className="text-center">
            <h3 className="text-5xl font-bold text-primary mb-2">5x</h3>
            <p className="text-muted-foreground">More Emails Processed in the same time</p>
          </div>
          <div className="text-center">
            <h3 className="text-5xl font-bold text-primary mb-2">100%</h3>
            <p className="text-muted-foreground">Privacy-first, zero email storage</p>
          </div>
        </div>
      </div>
    </section>
  );
};
